let ua = window.navigator.userAgent
let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
let webkit = !!ua.match(/WebKit/i)
let iOSSafari = iOS && webkit && !ua.match(/CriOS/i)

jQuery(document).ready(function () {
    jQuery('.bottom-mobile-bar--options--menu--button').on('click', function() {
        jQuery('.bottom-mobile-bar--options--menu, .bottom-mobile-bar').toggleClass('opened')
    })
    jQuery('.toggle-menu').on('click', function(){
        jQuery(this).toggleClass('clicked')
        jQuery(this).siblings('.nav-tabs').toggleClass('menu-opened')
    })
    jQuery('#toggle-search, #toggle-search-inner').on('click', function(e){
        e.preventDefault()
        jQuery('.main-header__search').fadeToggle('slow')
    })

    const focusInput = jQuery('.input-group-item > input')
    focusInput.focusin(function() {
        jQuery('.input-group-item > input').parent('.input-group-item').addClass('input-focused')
    })
    focusInput.focusout(function() {
        jQuery('.input-group-item > input').parent('.input-group-item').removeClass('input-focused')
    })

    jQuery('h1.component-heading').removeClass('mb-0')

    function moveBtn() {
        let screenWidth = jQuery(window).outerWidth()
        if (screenWidth > 991) {
            jQuery('.ser-fragment--container-left-image .ser-btn').appendTo('.ser-fragment--container-left-image__data')
        }
    }
    moveBtn()
    window.addEventListener('resize', function(){
        moveBtn()
    })

    $('.like-article').on('click', function(event) {
        var userId = Liferay.ThemeDisplay.getUserId();
        var articleId = $(this).attr('data-id');
        updateLikedArticle(articleId, userId);
    });

    $(".go-to-sign-document").on("click" , function(event) {
        jQuery("#nominas-menu").click();
    });

    if(!getCookie("alreadyShowSignDocument")){
        IdentityProviderJS.haveDocumentsToSign();
    }

        if(!getCookie("alreadyExpirationShowed")){
            IdentityProviderJS.haveChangePassSoon();
        }

    $("#modalSignDocument .close").on("click" , function(event) {
        $("#modalSignDocument").addClass("fade");
         $("#modalSignDocument").hide();
    });

    $("#modalChangePasswordSoon .close").on("click" , function(event) {
        $("#modalChangePasswordSoon").addClass("fade");
         $("#modalChangePasswordSoon").hide();
    });


})

function getCookie(name){
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=')
    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, '')
}

function openSignModal(){
    $("#modalSignDocument").removeClass("fade");
    $("#modalSignDocument").show();

}

function openChangePasswordSoon(){
    $("#modalChangePasswordSoon").removeClass("fade");
    $("#modalChangePasswordSoon").show();
}

function updateLikedArticle(articleId, userId) {
    Liferay.Service(
        '/su_bs.likedarticle/update-liked-article',
        {
            userId: userId,
            articleId: '' + articleId
        },
        function(result) {
                var selector = '.like-article[data-id="' + articleId +'"]';
                $.each($(selector), function(i, el) {
                    var likeCount = $(el).find('[data-id="heartCount"]');
                    var likes = parseInt($(likeCount).html());
                    if ($(el).find('.fa-star').hasClass('fas')) {
                        $(el).find('.fa-star').removeClass("fas");
                        $(el).find('.fa-star').addClass("far");
                        $(likeCount).html(likes-1);
                    } else if ($(el).find('.fa-star').hasClass('far')) {
                        $(el).find('.fa-star').removeClass("far");
                        $(el).find('.fa-star').addClass("fas");
                        var likes = parseInt($(likeCount).html());
                        $(likeCount).html(likes+1);
                    }
                });

        }
    );
}

const browserOS = navigator.userAgent
if (browserOS.includes('Macintosh')) {
    document.body.classList.add('macintosh')
} else if (browserOS.includes('Windows')) {
    document.body.classList.add('windows')
} else if (browserOS.includes('Linux')) {
    document.body.classList.add('linux')
}

/*
 * This function gets loaded when all the HTML, not including the portlets, is
 * loaded.
 */
AUI().ready(function () {});

/*
 * This function gets loaded after each and every portlet on the page.
 *
 * portletId: the current portlet's id
 * node: the Alloy Node object of the current portlet
 */
Liferay.Portlet.ready(function (_portletId, _node) {});

/*
 * This function gets loaded when everything, including the portlets, is on
 * the page.
 */
Liferay.on('allPortletsReady', function () {

    if (jQuery('#aperitivos-carousel') && jQuery('#noticias-vertical')) {
        const aperitivosCarousel = jQuery('#aperitivos-carousel').outerHeight()
        const noticiasVertical =  jQuery('#noticias-vertical').outerHeight()

        // console.log(aperitivosCarousel + ' ' + noticiasVertical)
        if (noticiasVertical < aperitivosCarousel) {
            jQuery('#noticias-vertical').css('height',aperitivosCarousel)
        } else if (aperitivosCarousel < noticiasVertical) {
            jQuery('#aperitivos-carousel').css('height',noticiasVertical + 15)
        }
    }

    if (jQuery('.promocion') && jQuery('.apps-portlet')) {
        const promotion = jQuery('.promocion').outerHeight()
        const appsPortlet =  jQuery('.apps-portlet').outerHeight()

        if (promotion < appsPortlet) {
            jQuery('.promocion').css('height',appsPortlet)
        } else if (appsPortlet < promotion) {
            jQuery('.apps-portlet').css('height',promotion)
        }
    }

    if (jQuery('.main-header__alerts')) {
        // Get public key and user auth from the subscription object
        var userId = Liferay.ThemeDisplay.getUserId();
        // This example uses the new fetch API. This is not supported in all
        // browsers yet.
        fetch('/o/serunion-push-service/notification/count/'+userId, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain'
        }
        }).then(response=>response.json()).then(data=>{
            jQuery('.main-header__alerts').text(data);
        });
    }

});
